module.exports = __webpack_public_path__ + "img/shipping.122b529d.svg";